export class UpdateSnapshotRecipeRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "revision",
            "baseName": "revision",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "baseSnapshotId",
            "baseName": "baseSnapshotId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "proposal",
            "baseName": "proposal",
            "type": "SnapshotRecipeProposal",
            "format": ""
        },
        {
            "name": "rules",
            "baseName": "rules",
            "type": "Array<SnapshotRecipeRule>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateSnapshotRecipeRequest.attributeTypeMap;
    }
    constructor() {
    }
}
